import { previewPhoto } from "@common-reducers/ExtraDataReducer";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useCallback, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import classes from './image-previewer.module.scss';

export default function ImagePreviewer() {
  const dispatch = useAppDispatch()
  const imagePreview = useAppSelector((state) => state.ExtraDataReducer.imagePreview);


  const handleClose = useCallback(() => {
    dispatch(previewPhoto({ isActive: false, imageURL: "" }))
  }, [dispatch]);

  // Close on Escape key.
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handleClose]);

  // Close when clicking the backdrop (but not the image itself).
  const handleBackdropClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  }, [handleClose]);


  return (
    <div className={classes.container} onClick={handleBackdropClick}>
      <div className={classes.image_wrapper}>
        <button className={classes.close_button} onClick={handleClose}>
          <MdClose />
        </button>
        <img style={{height:"90vh",maxWidth:"100%"}} src={imagePreview.imageURL} />
      </div>
    </div>
  );
}
